// src/components/EditListButton/EditListButton.tsx
import React, { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ReactComponent as EditListIcon } from '../../assets/edit-list.svg';
import { getWordsListLink } from '../../constants/Path';

interface EditListButtonProps {
  listId: string | number;
}

export const EditListButton: FC<EditListButtonProps> = ({ listId }) => {
  const { t } = useTranslation();
  const history = useHistory();

  const handleClick = () => {
    const id = typeof listId === 'string' ? parseInt(listId, 10) : listId;
    history.push(getWordsListLink(id));
  };

  // Pozycja menu opcji gry — wygląd daje RightSideButtons.less
  return (
    <button
      type="button"
      className="edit-list-button"
      onClick={handleClick}
    >
      <EditListIcon className="edit-list-icon" />
      {t('games:buttons.editList')}
    </button>
  );
};
